const TOKEN_KEY = 'tts_web_session';
const KIND_KEY = 'tts_session_kind';
const RECOVERY_KEY = 'tts_guest_recovery_token';

// Only the server-issued session credential lives on the device. Notes and
// settings continue to live exclusively in the existing Tap Talk Save backend.
export const session = {
  get() {
    const persistent = localStorage.getItem(TOKEN_KEY);
    if (persistent) return persistent;
    const legacy = sessionStorage.getItem(TOKEN_KEY);
    if (legacy) {
      localStorage.setItem(TOKEN_KEY, legacy);
      localStorage.setItem(KIND_KEY, 'account');
      sessionStorage.removeItem(TOKEN_KEY);
    }
    return legacy;
  },
  set(token, kind) {
    if (typeof token !== 'string' || !token.trim()) throw new Error('Tap Talk Save did not return a valid session. Please retry.');
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(KIND_KEY, kind);
    sessionStorage.removeItem(TOKEN_KEY);
  },
  kind: () => localStorage.getItem(KIND_KEY),
  setKind: kind => localStorage.setItem(KIND_KEY, kind),
  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(KIND_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
  },
  retainGuest(token) { if (token) localStorage.setItem(RECOVERY_KEY, token); },
  retainedGuest: () => localStorage.getItem(RECOVERY_KEY),
  finishMigration: () => localStorage.removeItem(RECOVERY_KEY),
};

export const isGuestUser = user => user?.is_guest === true || (user?.is_guest !== false && session.kind() === 'guest');

// Serialize initial guest creation across tabs where supported. A module-level
// promise also prevents duplicate requests from React remounts in the same tab.
let pendingGuest;
export function ensureGuestSession(createGuest) {
  if (pendingGuest) return pendingGuest;
  const establish = async () => {
    if (session.get()) return;
    const result = await createGuest();
    // Never overwrite an account another tab has just connected.
    if (!session.get()) session.set(result?.session_token, 'guest');
  };
  pendingGuest = (navigator.locks
    ? navigator.locks.request('tts-session-bootstrap', establish)
    : establish()).finally(() => { pendingGuest = null; });
  return pendingGuest;
}